import "./src/styles/global.css"
import { trackPageView } from "./src/utils/Analytics"

let observer = null
let warningTimer = null
let maxWaitTimer = null

const MAX_LOADER_WAIT = 2500

function attachDismissButton() {
  const button = document.getElementById("___loader-dismiss")
  if (button) {
    button.onclick = () => {
      const loader = document.getElementById("___loader")
      loader?.classList?.add("brand-loader-hide")
      hideWarning()
      clearTimeout(warningTimer)
      clearTimeout(maxWaitTimer)
      if (observer) {
        observer.disconnect()
        observer = null
      }
    }
  }
}

function showWarning() {
  document.getElementById("___loader-warning")?.classList?.remove("hidden")
}

function hideWarning() {
  document.getElementById("___loader-warning")?.classList?.add("hidden")
}

function scrollToHash(hash) {
  if (!hash) return
  const element = document.querySelector(hash)
  if (element) {
    window.scrollTo({
      top: element.getBoundingClientRect().top + window.scrollY - 100,
      behavior: "smooth",
    })
  }
}

function watchForReady(hash) {
  const loader = document.getElementById("___loader")

  // Disconnect any previous observer (important on route changes)
  if (observer) {
    observer.disconnect()
    observer = null
  }

  // Clear any previous warning timer and hide the warning
  if (warningTimer) {
    clearTimeout(warningTimer)
    warningTimer = null
  }
  if (maxWaitTimer) {
    clearTimeout(maxWaitTimer)
    maxWaitTimer = null
  }
  hideWarning()

  // Check immediately — handles pages with no videos
  if (document.querySelectorAll(".brand-wait").length === 0) {
    loader?.classList?.add("brand-loader-hide")
    scrollToHash(hash)
    return
  }

  // Never hold the page hostage to third-party video/CDN readiness.
  maxWaitTimer = setTimeout(() => {
    loader?.classList?.add("brand-loader-hide")
    hideWarning()
    clearTimeout(warningTimer)
    if (observer) {
      observer.disconnect()
      observer = null
    }
    scrollToHash(hash)
  }, MAX_LOADER_WAIT)

  // Show warning only if something is very stuck.
  warningTimer = setTimeout(showWarning, 6000)

  observer = new MutationObserver(() => {
    if (document.querySelectorAll(".brand-wait").length === 0) {
      loader?.classList?.add("brand-loader-hide")
      hideWarning()
      clearTimeout(warningTimer)
      clearTimeout(maxWaitTimer)
      observer.disconnect()
      observer = null
      scrollToHash(hash)
    }
  })

  observer.observe(document.body, {
    subtree: true,
    attributes: true,
    attributeFilter: ["class"],
  })
}

if (typeof window !== "undefined") {
  window.dismissLoader = () => {
    const loader = document.getElementById("___loader")
    loader?.classList?.add("brand-loader-hide")
    hideWarning()
    clearTimeout(warningTimer)
    clearTimeout(maxWaitTimer)
    if (observer) {
      observer.disconnect()
      observer = null
    }
  }
}

export const onInitialClientRender = () => {
  attachDismissButton()
  watchForReady(window.location.hash)
}

export const onRouteUpdate = ({ location }) => {
  const loader = document.getElementById("___loader")
  loader?.classList?.remove("brand-loader-hide")
  watchForReady(location.hash)

  // Gatsby navigation happens client-side, so explicitly record every route.
  window.setTimeout(() => trackPageView(location), 0)
}
